<template>
  <div class="unread-badge-wrapper">
    <v-btn
      text
      @click="handleClick"
      class="message-btn"
    >
      <v-badge
        :content="displayCount"
        :value="unreadCount > 0"
        color="red"
        :offset-x="10"
        :offset-y="10"
        class="message-badge"
      >
        <v-icon>mdi-message-outline</v-icon>
      </v-badge>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'UnreadBadge',
  
  props: {
    maxDisplay: {
      type: Number,
      default: 99
    },
    showAnimation: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters('messages', ['unreadCount']),
    
    displayCount() {
      if (this.unreadCount > this.maxDisplay) {
        return `${this.maxDisplay}+`;
      }
      return this.unreadCount.toString();
    }
  },

  watch: {
    unreadCount(newCount, oldCount) {
      if (this.showAnimation && newCount > oldCount) {
        this.animateBadge();
      }
    }
  },

  methods: {
    ...mapActions('messages', ['fetchUnreadCount']),
    
    handleClick() {
      this.$emit('click');
    },
    
    animateBadge() {
      // Add animation class
      const badgeEl = this.$el.querySelector('.v-badge__badge');
      if (badgeEl) {
        badgeEl.classList.add('badge-pulse');
        
        // Remove animation class after animation completes
        setTimeout(() => {
          if (badgeEl) {
            badgeEl.classList.remove('badge-pulse');
          }
        }, 600);
      }
    }
  },

  mounted() {
    // Fetch initial unread count
    this.fetchUnreadCount();
    
    // Update count every 30 seconds
    this.updateInterval = setInterval(() => {
      this.fetchUnreadCount();
    }, 30000);
  },

  beforeDestroy() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  }
};
</script>

<style scoped>
.unread-badge-wrapper {
  display: inline-flex;
  align-items: center;
}

.message-btn {
  margin: 0 4px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.badge-pulse {
  animation: pulse 0.6s ease-in-out;
}

>>> .v-badge__badge {
  font-size: 11px;
  font-weight: 600;
  height: 18px;
  width: auto;
  min-width: 18px;
  padding: 0 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

>>> .v-badge__wrapper {
  margin: 0;
}

>>> .message-badge .v-badge__badge {
  top: 0;
  right: 0;
}
</style>